(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["emmett-image-upload"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    const imageInput = document.getElementById('image-upload');
    const preview = document.getElementById('preview');

    imageInput.addEventListener('change', function() {
        const file = this.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = function(e) {
                preview.src = e.target.result;
                preview.style.display = 'block';  // Display the image
            };
            reader.readAsDataURL(file);
        }
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-necklace-story"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {
  const button=event.target.closest('[data-mpn-jump]');if(!button)return;
  const form=document.querySelector('mp-necklace form');
  if(form){event.preventDefault();form.scrollIntoView({behavior:'smooth',block:'start'});form.querySelector('[name="id"]:checked')?.focus({preventScroll:true});}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-necklace"]) return;
  try {
    
if (!customElements.get('mp-necklace')) {
  customElements.define('mp-necklace', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) { this.watchEditorPlaceholder(); this.watchMobileControls(); return; }
      this.ready = true;
      this.q = (s) => this.querySelector(s);
      this.qa = (s) => [...this.querySelectorAll(s)];
      this.words = JSON.parse(this.q('[data-mpn-strings]').textContent);
      this.form = this.q('form');
      this.cards = this.qa('[data-pet-id]');
      this.busy = false;
      this.pending = 0;
      this.activeImage = 0;
      this.count = 0;
      this.q('[data-submit]').disabled = false;
      this.form.noValidate = true;
      this.form.addEventListener('submit', (e) => { e.preventDefault(); e.stopImmediatePropagation(); this.submit(); }, true);
      // App cart handlers target native submit buttons and omit file inputs.
      // This dedicated action runs our multipart upload and response checks.
      this.q('[data-submit]').addEventListener('click', e => {
        e.preventDefault(); e.stopImmediatePropagation(); this.submit();
      }, true);
      this.form.addEventListener('keydown', e => {
        if(e.key==='Enter' && !e.isComposing && e.target.matches('input[type="text"]')) {
          e.preventDefault(); e.stopImmediatePropagation(); this.submit();
        }
      }, true);
      this.qa('[name="id"]').forEach(radio => radio.addEventListener('change', () => this.chooseCount(radio, true)));
      this.cards.forEach(card => {
        const photo = card.querySelector('[data-photo]');
        const name = card.querySelector('[data-name]');
        photo.addEventListener('change', () => this.readPhoto(card));
        name.addEventListener('input', () => {
          name.setCustomValidity(name.value.trim() && Array.from(name.value).length <= Number(this.dataset.nameLimit) ? '' : this.words.name_error);
          card.querySelector('[data-card-name]').textContent = name.value || this.words.your_pet;
          this.changed(); this.renderOrder();
        });
        card.querySelectorAll('[data-move]').forEach(button => button.addEventListener('click', () => this.move(card, Number(button.dataset.move))));
      });
      this.q('[data-personalize]').addEventListener('click', () => {
        this.form.scrollIntoView({behavior: 'smooth', block: 'start'});
        const field = [...this.form.querySelectorAll('input')].find(input => !input.matches(':disabled') && !input.checkValidity());
        if (field) field.focus({preventScroll:true});
      });
      this.qa('[data-thumb]').forEach(b => b.addEventListener('click', () => this.showImage(Number(b.dataset.thumb))));
      this.q('[data-gallery-prev]')?.addEventListener('click', () => this.showImage(this.activeImage-1));
      this.q('[data-gallery-next]')?.addEventListener('click', () => this.showImage(this.activeImage+1));
      this.qa('[data-slide]').forEach(slide => slide.addEventListener('click', () => {
        const source = slide.querySelector('img');
        const im = this.q('[data-zoom-image]'); im.src = source.currentSrc || source.src; im.alt = source.alt;
        this.q('[data-zoom]').showModal();
      }));
      this.q('[data-open-guide]').addEventListener('click', () => this.q('[data-guide]').showModal());
      this.qa('[data-close]').forEach(button => button.addEventListener('click', () => button.closest('dialog').close()));
      this.qa('dialog').forEach(dialog => dialog.addEventListener('click', e => { if (e.target === dialog) { const r=dialog.getBoundingClientRect(); if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom) dialog.close(); } }));
      let startX = null;
      this.q('.mpn-stage').addEventListener('touchstart', e => {startX=e.touches[0].clientX;}, {passive:true});
      this.q('.mpn-stage').addEventListener('touchend', e => {if(startX!==null && Math.abs(startX-e.changedTouches[0].clientX)>60) this.showImage(this.activeImage+(startX>e.changedTouches[0].clientX?1:-1));startX=null;}, {passive:true});
      this.chooseCount(this.q('[name="id"]:checked'), false);
      this.watchEditorPlaceholder();
      this.watchMobileControls();
      this.qa('[data-help]').forEach(link => link.addEventListener('click', event => {
        if (typeof window.FreshworksWidget === 'function') {
          event.preventDefault(); window.FreshworksWidget('open');
        }
      }));
      window.addEventListener('pageshow', () => {if(!this.busy) this.q('[data-submit]').disabled = !this.count;});
    }
    watchEditorPlaceholder() {
      if (this.dataset.designMode !== 'true') return;
      // Only the observed empty Zepto editor notice, never configured app fields.
      const hideNotice = () => {
        const notice = 'Zepto Product Personalizer Options will be visible here when the product is configured by the app';
        const normalize = value => value.replace(/\s+/g, ' ').trim();
        const walker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT);
        let text;
        while ((text = walker.nextNode())) {
          if (normalize(text.textContent) !== notice) continue;
          let element = text.parentElement;
          while (element.parentElement !== this && normalize(element.parentElement.textContent) === notice) element = element.parentElement;
          if (!element.querySelector('input,select,textarea,button')) element.hidden = true;
        }
      };
      hideNotice();
      this.editorObserver ||= new MutationObserver(hideNotice);
      this.editorObserver.observe(this, {childList:true, subtree:true, characterData:true});
    }
    watchMobileControls() {
      const sticky = this.q('.mpn-sticky');
      this.purchaseObserver?.disconnect();
      if ('IntersectionObserver' in window) {
        this.purchaseObserver = new IntersectionObserver(entries => {
          sticky.hidden = entries.some(entry => entry.isIntersecting);
        }, {rootMargin:'-90px 0px 90px 0px', threshold:0});
        this.purchaseObserver.observe(this.q('[data-submit]'));
      }
      if (!window.matchMedia) return;
      this.mobileQuery ||= window.matchMedia('(max-width: 899px)');
      this.syncHelp ||= () => {
        // This template supplies accessible Help links. Keep the floating
        // launcher off the mobile purchase controls, using the vendor API.
        if (typeof window.FreshworksWidget === 'function') {
          window.FreshworksWidget(this.mobileQuery.matches ? 'hide' : 'show', 'launcher');
        }
      };
      this.syncHelp();
      this.mobileQuery.addEventListener('change', this.syncHelp);
      window.addEventListener('load', this.syncHelp);
    }
    disconnectedCallback() {
      this.editorObserver?.disconnect(); this.purchaseObserver?.disconnect();
      this.mobileQuery?.removeEventListener('change', this.syncHelp);
      if (this.syncHelp) window.removeEventListener('load', this.syncHelp);
      if (typeof window.FreshworksWidget === 'function') window.FreshworksWidget('show', 'launcher');
    }
    changed() {
      this.q('[data-confirm]').checked = false;
      this.q('[data-error]').hidden = true;
      this.q('[data-configuration]').value = '';
    }
    chooseCount(radio, user) {
      const n = Number(radio?.dataset.count);
      if (!Number.isInteger(n) || n<1 || n>4 || radio.disabled) {this.count=0;this.q('[data-submit]').disabled=true;return;}
      if(user && n<this.count && this.cards.slice(n,this.count).some(c => c.querySelector('[data-name]').value || c.querySelector('[data-photo]').files.length)) {
        if(!window.confirm(this.words.remove_confirm)) {this.qa('[name="id"]').find(r=>Number(r.dataset.count)===this.count).checked=true;return;}
      }
      this.count = n;
      this.renumber(); this.changed(); this.renderOrder();
      this.qa('[data-price]:not(input)').forEach(e => e.textContent=radio.dataset.price);
      this.q('[data-submit]').disabled=false;
      if(user) {
        const u=new URL(window.location.href);u.searchParams.set('variant',radio.value);history.replaceState(null,'',u);
        this.q('[data-status]').textContent=this.words.count_changed;
      }
    }
    renumber() {
      this.cards.forEach((card,index) => {
        card.hidden=index>=this.count;card.disabled=index>=this.count;
        card.querySelector('[data-position]').textContent=index+1;
        card.querySelector('[data-photo]').name=`properties[Pet ${index+1} photo]`;
        card.querySelector('[data-name]').name=`properties[Pet ${index+1} name]`;
        card.querySelector('[data-move="-1"]').disabled=index===0;
        card.querySelector('[data-move="1"]').disabled=index===this.count-1;
        this.q('.mpn-pets').append(card);
      });
    }
    move(card,delta) {
      if(this.busy) return;
      const i=this.cards.indexOf(card), j=i+delta;
      if(j<0||j>=this.count) return;
      [this.cards[i],this.cards[j]]=[this.cards[j],this.cards[i]];
      this.renumber();this.changed();this.renderOrder();
      this.q('[data-status]').textContent=this.words.order_changed;
      card.querySelector('[data-name]').focus();
    }
    renderOrder() {
      const list=this.q('[data-order]');list.replaceChildren();
      const names=[];
      this.cards.slice(0,this.count).forEach((card,i) => {
        const li=document.createElement('li'), label=document.createElement('span');
        const name=card.querySelector('[data-name]').value;
        const preview=card.querySelector('[data-photo-preview]');
        if(!preview.hidden) {const img=document.createElement('img');img.src=preview.src;img.alt='';img.width=48;img.height=48;li.append(img);}
        label.textContent=`${i+1}. ${name || this.words.your_pet}`;li.append(label);list.append(li);names.push(`${i+1}: ${name}`);
      });
      this.q('[data-order-property]').value=names.join(' | ');
    }
    readOriginal(file) {
      return new Promise((resolve,reject)=>{
        const reader=new FileReader();
        const fail=()=>{clearTimeout(timer);reject(new Error('file_read'));};
        const timer=setTimeout(()=>{reader.abort();fail();},15000);
        reader.onerror=fail;reader.onabort=fail;
        reader.onload=()=>{
          clearTimeout(timer);
          if(!reader.result || reader.result.byteLength!==file.size){fail();return;}
          resolve(new File([reader.result],file.name,{type:file.type,lastModified:file.lastModified}));
        };
        try{reader.readAsArrayBuffer(file);}catch{fail();}
      });
    }
    async readPhoto(card) {
      const input=card.querySelector('[data-photo]'), preview=card.querySelector('[data-photo-preview]'), status=card.querySelector('[data-file-status]');
      const token=Symbol();card.photoToken=token;card.uploadFile=null;
      if(card.photoURL) {URL.revokeObjectURL(card.photoURL);card.photoURL=null;}
      preview.hidden=true;card.querySelector('[data-photo-empty]').hidden=false;
      input.setCustomValidity('');status.textContent='';this.changed();this.renderOrder();
      const file=input.files[0];if(!file)return;
      let error='';
      if(!['image/jpeg','image/png','image/webp'].includes(file.type)) error=this.words.file_type;
      else if(file.size>Number(this.dataset.limit)*1024*1024||file.size===0) error=this.words.file_size;
      if(error) {input.setCustomValidity(error);status.textContent=error;return;}
      this.pending++;
      status.textContent=this.words.file_preparing;
      let url,prepared=false;
      try {
        const uploadFile=await this.readOriginal(file);
        if(card.photoToken!==token)return;
        prepared=true;url=URL.createObjectURL(uploadFile);
        const image=new Image();image.src=url;await image.decode();
        if(card.photoToken!==token){URL.revokeObjectURL(url);return;}
        card.uploadFile=uploadFile;
        card.photoURL=url;preview.src=url;preview.hidden=false;card.querySelector('[data-photo-empty]').hidden=true;
        status.textContent=this.words.file_ready;this.renderOrder();
      } catch {
        if(url)URL.revokeObjectURL(url);
        if(card.photoToken===token) {const message=prepared?this.words.file_decode:this.words.file_read;input.setCustomValidity(message);status.textContent=message;}
      } finally {this.pending--;}
    }
    showImage(index) {
      const slides=this.qa('[data-slide]');if(!slides.length)return;
      this.activeImage=(index+slides.length)%slides.length;
      slides.forEach((s,i)=>s.hidden=i!==this.activeImage);
      this.qa('[data-thumb]').forEach((b,i)=>b.setAttribute('aria-pressed',String(i===this.activeImage)));
      const counter=this.q('[data-gallery-counter]');if(counter)counter.textContent=`${this.activeImage+1} / ${slides.length}`;
    }
    error(message,cartLink=false) {
      this.q('[data-upload]').hidden=true;
      const box=this.q('[data-error]');box.textContent=message;box.hidden=false;
      if(cartLink) {const a=document.createElement('a');a.href=this.dataset.cartUrl;a.textContent=this.words.open_cart;box.append(document.createTextNode(' '),a);}
      box.focus();
    }
    uploaded(line,count) {
      return Array.from({length:count},(_,i)=>line?.properties?.[`Pet ${i+1} photo`]).every(value=>typeof value==='string' && /^(https?:\/\/|\/\/|\/uploads\/)/.test(value) && !value.includes('blob:'));
    }
    async reconcile(id) {
      const controller=new AbortController();
      const timer=setTimeout(()=>controller.abort(),10000);
      try {
        const response=await fetch(this.dataset.cartUrl+'.js',{credentials:'same-origin',cache:'no-store',signal:controller.signal});
        if(!response.ok)throw new Error('cart');
        const cart=await response.json();return cart.items.find(item=>item.properties?._mp_configuration===id);
      } finally {clearTimeout(timer);}
    }
    async settleRetry(id,count) {
      const controller=new AbortController();
      const timer=setTimeout(()=>controller.abort(),10000);
      try {
        const response=await fetch(this.dataset.cartUrl+'.js',{credentials:'same-origin',cache:'no-store',signal:controller.signal});
        if(!response.ok)throw new Error('cart');
        const cart=await response.json();
        const lines=cart.items.filter(line=>line.properties?._mp_configuration===id);
        const keep=lines.find(line=>this.uploaded(line,count));
        if(!keep)throw new Error('missing');
        // Remove only duplicate lines bearing this submission's private ID.
        // Other necklaces, even with the same variant, remain untouched.
        for(const line of lines)if(line.key!==keep.key)await this.removeOwnLine(line);
        return keep;
      } finally {clearTimeout(timer);}
    }
    async removeOwnLine(line) {
      const response=await fetch(this.dataset.cartUrl+'/change.js',{method:'POST',headers:{'Content-Type':'application/json'},credentials:'same-origin',body:JSON.stringify({id:line.key,quantity:0})});
      if(!response.ok)throw new Error('remove');
    }
    async retryPending() {
      if(this.checking || !this.pendingAttempt)return;
      this.checking=true;
      this.q('[data-submit]').disabled=true;
      const attempt=this.pendingAttempt;
      try {
        // A fresh cart read must succeed before the customer can retry.
        // Reuse the attempt ID so a delayed successful response is recognized.
        const line=await this.reconcile(attempt.nonce);
        if(line && this.uploaded(line,attempt.count)){await this.showVerifiedCart();return;}
        if(line)await this.removeOwnLine(line);
        this.lock(false);
        this.retryNonce=attempt.nonce;
        this.checking=false;
        return this.submit();
      } catch {this.retryReady=false;this.unconfirmed();}
      finally {this.checking=false;}
    }
    unconfirmed() {
      this.uncertain=true;
      this.form.setAttribute('aria-busy','false');
      this.q('[data-submit]').disabled=false;
      this.q('[data-submit]').textContent=this.words.check_cart;
      this.error(this.words.uncertain,true);
    }
    async checkPending() {
      if(this.checking || !this.pendingAttempt)return;
      this.checking=true;
      this.q('[data-submit]').disabled=true;
      this.q('[data-submit]').textContent=this.words.checking_cart;
      this.form.setAttribute('aria-busy','true');
      this.q('[data-error]').hidden=true;
      this.uploadStatus(this.words.upload_reconciling);
      try {
        const line=await this.reconcile(this.pendingAttempt.nonce);
        if(line && this.uploaded(line,this.pendingAttempt.count)) {
          await this.showVerifiedCart();return;
        }
        if(line)await this.removeOwnLine(line);
        this.retryReady=true;
        this.form.setAttribute('aria-busy','false');
        this.q('[data-submit]').disabled=false;
        this.q('[data-submit]').textContent=this.words.retry_upload;
        this.error(this.words.retry_ready,true);
        return;
      } catch {}
      finally {this.checking=false;}
      this.unconfirmed();
    }
    lock(value) {
      if(!value){this.uncertain=false;this.retryReady=false;this.pendingAttempt=null;}
      this.busy=value;this.form.setAttribute('aria-busy',String(value));
      this.q('[data-submit]').disabled=value;
      this.q('[data-submit]').textContent=value?this.words.uploading:this.words.add;
      this.qa('fieldset').forEach(field=>field.disabled=value);
      if(!value) this.renumber();
      this.q('[data-confirm]').disabled=value;
      if(!value)this.q('[data-upload]').hidden=true;
    }
    uploadStatus(message,percent=null) {
      this.q('[data-upload]').hidden=false;
      const status=this.q('[data-upload-status]'),bar=this.q('[data-upload-progress]');
      const text=percent===null?message:`${message} ${percent}%`;
      if(status.textContent!==text)status.textContent=text;
      if(percent===null)bar.removeAttribute('value');else bar.value=percent;
    }
    sendPhotos(body) {
      return new Promise((resolve,reject)=>{
        const request=new XMLHttpRequest();
        request.upload.addEventListener('progress',event=>{
          if(event.lengthComputable && event.total>0) {
            const percent=Math.min(100,Math.floor(event.loaded/event.total*100));
            if(percent===100)this.uploadStatus(this.words.upload_verifying);
            else this.uploadStatus(this.words.uploading,percent);
          }
        });
        request.upload.addEventListener('load',()=>this.uploadStatus(this.words.upload_verifying));
        request.addEventListener('load',()=>resolve({ok:request.status>=200 && request.status<300,status:request.status,json:async()=>JSON.parse(request.responseText)}));
        ['error','abort','timeout'].forEach(event=>request.addEventListener(event,()=>reject(new Error(event))));
        request.open('POST',this.dataset.addUrl,true);
        // Four 5 MiB originals need about 224 seconds at 0.75 Mbps,
        // before overhead. Keep the originals and allow ten minutes.
        request.timeout=600000;
        request.setRequestHeader('Accept','application/json');
        request.send(body);
      });
    }
    async showVerifiedCart() {
      this.uploadStatus(this.words.upload_opening);
      // Uploads have already been saved. Refresh the existing AMP drawer,
      // without submitting the product again through the cart app.
      const opened = await new Promise(resolve => {
        if(typeof window.SLIDECART_UPDATE!=='function' || typeof window.SLIDECART_OPEN!=='function') {resolve(false);return;}
        let settled=false;
        const finish=value=>{if(settled)return;settled=true;clearTimeout(timer);resolve(value);};
        const timer=setTimeout(()=>finish(false),8000);
        try {
          window.SLIDECART_UPDATE(()=>{
            if(settled)return;
            try {window.SLIDECART_OPEN();finish(true);}catch {finish(false);}
          });
        } catch {finish(false);}
      });
      if(opened) {
        this.lock(false);
        // Retain the customer's inputs, but require a fresh confirmation
        // before another copy can be added after the drawer is closed.
        this.changed();
      } else {
        // A drawer failure must never retry an already successful upload.
        window.location.assign(this.dataset.cartUrl);
      }
    }
    async submit() {
      if(this.uncertain)return this.retryReady?this.retryPending():this.checkPending();
      if(this.busy)return;
      if(!this.count) {this.error(this.words.invalid_count);return;}
      if(this.pending) {this.error(this.words.photo_pending);return;}
      this.cards.slice(0,this.count).forEach(card=>{
        const n=card.querySelector('[data-name]');n.setCustomValidity(n.value.trim()&&Array.from(n.value).length<=Number(this.dataset.nameLimit)?'':this.words.name_error);
      });
      if(!this.form.reportValidity()) {this.error(this.words.missing);return;}
      if(this.cards.slice(0,this.count).some(card=>!card.uploadFile)){this.error(this.words.file_read);return;}
      this.renderOrder();
      const wasRetry=Boolean(this.retryNonce);
      const nonce=this.retryNonce||crypto.randomUUID();this.retryNonce=null;this.q('[data-configuration]').value=nonce;
      const body=new FormData(this.form);
      const count=this.count;
      this.cards.slice(0,count).forEach((card,index)=>body.set(`properties[Pet ${index+1} photo]`,card.uploadFile,card.uploadFile.name));
      this.pendingAttempt={nonce,count};
      this.lock(true);this.q('[data-error]').hidden=true;
      this.uploadStatus(this.words.uploading,0);
      try {
        const response=await this.sendPhotos(body);
        if(!response.ok) {
          if(response.status>=500)throw new Error('server');
          let detail='';
          try {
            const rejection=await response.json();
            if(typeof rejection.description==='string') detail=rejection.description;
          } catch { /* Non-JSON responses keep the translated fallback. */ }
          this.lock(false);
          // error() uses textContent. Never render API error text as HTML.
          this.error(detail ? `${detail} ${this.words.submit_error}` : this.words.submit_error);
          return;
        }
        const result=await response.json();const line=result.items?result.items[0]:result;
        if(!this.uploaded(line,count)) {
          const root=this.dataset.cartUrl.replace(/\/cart$/,'');
          const removal=await fetch(root+'/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:line.key,quantity:0}),credentials:'same-origin'});
          if(!removal.ok)throw new Error('remove');
          this.lock(false);this.error(this.words.upload_incomplete);return;
        }
        if(wasRetry)await this.settleRetry(nonce,count);
        await this.showVerifiedCart();
      } catch {
        this.uploadStatus(this.words.upload_reconciling);
        try {
          const line=await this.reconcile(nonce);
          if(line && this.uploaded(line,count)){await this.showVerifiedCart();return;}
        }catch{}
        this.unconfirmed();
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
